import type { SocialProviderName } from '@repo/api-contracts';

/** 소셜 제공자 표시 이름 — 계약의 제공자가 늘면 이 표가 컴파일되지 않는다. */
const SOCIAL_PROVIDER_LABELS: Record<SocialProviderName, string> = {
  naver: '네이버',
  kakao: '카카오',
  google: '구글',
};

export const socialProviderLabel = (provider: SocialProviderName): string =>
  SOCIAL_PROVIDER_LABELS[provider];
